import { joinPathsStringUtil } from 'packages/src'
import { MESSAGES_PATH } from '../../state'
import { MESSAGE_KEY } from '../constants'
import { getDataPathReduxUtil } from '../../../redux/utils/get-data-path'
import { getValueReduxUtil } from '../../../redux/utils/get-value'

export function getDomainListPathFromChatIdMessageUtil (chatId) {
  return joinPathsStringUtil(MESSAGES_PATH.BY_CHAT_ID, chatId)
}

export function getDomainListDataPathFromChatIdMessageUtil (chatId) {
  return getDataPathReduxUtil(joinPathsStringUtil(
    MESSAGES_PATH.BY_CHAT_ID,
    chatId
  ))
}

export function getDomainListPathsMessageUtil (instance) {
  const chatId = getValueReduxUtil(instance, MESSAGE_KEY.CHAT_ID)
  const domainListPath = getDomainListPathFromChatIdMessageUtil(chatId)
  return [domainListPath]
}
